import Vue from 'vue';
import ElementUi from 'element-ui';
import VueForm from '@lljj/vue-json-schema-form';
import PageEngine from '@/components/page-engine/Index';
import FormEngine from '@/components/form-engine/Index';
import CommonTable from '@/components/common-table/Index';
import ImageUpload from '@/components/image-upload/Main';
// import 'element-ui/lib/theme-chalk/index.css';
import '../public/stylesheets/element-variables.scss';
import VueRoutes from '@/route/vue-routes';
import notFound from '@/container/NotFound';
import filters from './util/filters';
import '@/components/directive';
import { getLapiSubjectList } from '@/api/dictionary.js';
window.admApiVersion = '/v1';

Vue.use(ElementUi);
Vue.component('PageEngine', PageEngine);
Vue.component('FormEngine', FormEngine);
Vue.component('CommonTable', CommonTable);
Vue.component('ZxForm', VueForm);
Vue.component('ImageUpload', ImageUpload);

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

function safeDecode (text) {
    try {
        return decodeURIComponent(text);
    } catch (err) {
        return text;
    }
}

function parseHostQuery (queryString) {
    const query = {};

    if (!queryString) {
        return query;
    }
    queryString.split('&').forEach(item => {
        if (!item) {
            return;
        }
        const pair = item.split('=');
        const key = safeDecode(pair.shift().replace(/\+/g, ' '));
        const value = safeDecode(pair.join('=').replace(/\+/g, ' '));

        if (key) {
            query[key] = value;
        }
    });
    return query;
}

function stringifyHostQuery (query) {
    const pairs = [];

    Object.keys(query || {}).forEach(key => {
        const value = query[key];
        const appendPair = item => {
            if (item === undefined || item === null) {
                return;
            }
            pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        };

        if (Array.isArray(value)) {
            value.forEach(appendPair);
        } else {
            appendPair(value);
        }
    });
    return pairs.length ? `?${pairs.join('&')}` : '';
}

function buildHostRoute (hash) {
    const rawHash = (hash || '').replace(/^#/, '');
    const hashPair = rawHash.split('?');
    const pathText = hashPair.shift() || '';
    const queryString = hashPair.join('?');
    const segments = pathText.split('/').filter(Boolean).map(safeDecode);
    const name = segments[0] || '';
    const params = {};
    const query = parseHostQuery(queryString);

    if (name === 'voice-flow-detail' && segments[1]) {
        params.ivxCallId = segments[1];
    }
    return {
        name,
        path: `/${segments.join('/')}`,
        fullPath: `/${segments.join('/')}${queryString ? `?${queryString}` : ''}`,
        params,
        query,
    };
}

function resolveHostHash (location) {
    if (typeof location === 'string') {
        return location.indexOf('#') === 0 ? location : `#${location.replace(/^\//, '')}`;
    }

    const nextLocation = location || {};
    const queryText = stringifyHostQuery(nextLocation.query || {});
    let pathText = '';

    if (nextLocation.path) {
        pathText = nextLocation.path.replace(/^\//, '');
    } else if (nextLocation.name) {
        const segments = [nextLocation.name];

        if (
            nextLocation.name === 'voice-flow-detail' &&
            nextLocation.params &&
            nextLocation.params.ivxCallId
        ) {
            segments.push(encodeURIComponent(nextLocation.params.ivxCallId));
        }
        pathText = segments.join('/');
    }
    return `#${pathText}${queryText}`;
}

const hostRouteState = Vue.observable({
    route: buildHostRoute(window.location.hash),
});

function syncHostRoute () {
    hostRouteState.route = buildHostRoute(window.location.hash);
}

const hostRouter = {
    push (location) {
        const hash = resolveHostHash(location);

        if (window.location.hash === hash) {
            syncHostRoute();
            return;
        }
        window.location.hash = hash;
    },
    replace (location) {
        const hash = resolveHostHash(location);

        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
            syncHostRoute();
            return;
        }
        this.push(location);
    },
};

Object.defineProperty(Vue.prototype, '$route', {
    configurable: true,
    get () {
        return hostRouteState.route;
    },
});

Object.defineProperty(Vue.prototype, '$router', {
    configurable: true,
    get () {
        return hostRouter;
    },
});

window.addEventListener('hashchange', syncHostRoute);

const vm = new Vue({
    el: '#vue_container',
    components: {
        notFound: notFound,
        ...VueRoutes,
    },
    data: {
        currentRoute: window.location.hash,
        excludeComponent: [],
        menuList: [],
        isReady: false,
    },
    mounted () {
        try {
            this.menuList = JSON.parse(localStorage.getItem('menuList'));
        } catch (error) {
            this.menuList = [];
        }
    },
    created () {
        this.getSubjectDictionary();
        window.onhashchange = () => {
            this.currentRoute = window.location.hash;
            this.excludeComponent = [];
            try {
                this.menuList = JSON.parse(localStorage.getItem('menuList'));
                const routeName = this.currentRoute.replace('#', '').split('?')[0].split('/')[0];

                if (!this.isMenu(this.menuList)) {
                    this.excludeComponent = [routeName];
                    this.currentRoute = '';
                    this.$nextTick(() => {
                        this.currentRoute = window.location.hash;
                    });
                }
            } catch (err) {
                console.log(err);
            }
        };
        window.addEventListener('message', (event) => {
            const params = event.data || {};
            if (params.from === 'menuHistory') {
                const routeName = this.currentRoute.replace('#', '').split('?')[0].split('/')[0];
                const h = VueRoutes[routeName];

                if (this.currentRoute === params.url) {
                    // 当前页面刷新
                    if (h) {
                        // vue页面
                        const compName = this.ViewComponent;
                        this.excludeComponent = [compName];
                        this.currentRoute = '';
                        this.$nextTick(() => {
                            this.currentRoute = window.location.hash;
                        });
                    } else {
                        // backbone页面
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    }
                } else {
                    // 切换页面刷新
                    this.excludeComponent = [params.url.replace('#', '').split('?')[0].split('/')[0]];
                    window.location.href = params.url;
                }
            }
        });
    },
    methods: {
        isMenu (list) {
            let res = false;
            const routeName = this.currentRoute.replace('#', '').split('?')[0].split('/')[0];
            for (let item of list) {
                if (item.children) {
                    res = this.isMenu(item.children);
                    if (res) {
                        break;
                    }
                } else {
                    if (item.uri === routeName) {
                        res = true;
                        break;
                    }
                }
            }
            return res;
        },
        // 获取学科字典
        getSubjectDictionary () {
            getLapiSubjectList({
                data: {
                    scene: 'all',
                },
            }).then(res => {
                const { code, data: subject } = res;
                if (code === 1) {
                    this.isReady = true;
                    APP.subjectList = {};
                    APP.codes.GRADE_TYPE = {};
                    APP.codes.SUBJECT_TYPE = {};
                    APP.codes.SEARCH_SUBJECT_TYPE = {};
                    subject.forEach(item => {
                        APP.subjectList[item.subject] = item;
                        APP.codes.GRADE_TYPE[item.grade] = item.grade;
                        APP.codes.SUBJECT_TYPE[item.subject_name] = item.subject_name;
                        APP.codes.SEARCH_SUBJECT_TYPE[item.subject_name] = item.subject_name;
                        APP.codes.EN_ZH_SUBJECT_TYPE[item.subject] = item.grade + item.subject_name;
                    });
                    delete APP.codes.SEARCH_SUBJECT_TYPE['自招'];
                }
            });
        },
    },
    computed: {
        // 匹配上的组件名称
        ViewComponent () {
            const routeName = this.currentRoute.replace('#', '').split('?')[0].split('/')[0];
            const h = VueRoutes[routeName];

            if (h) {
                $('#vue_primary_content').removeClass('hide').siblings('#primary_content').addClass('hide');
                return routeName;
            }
            return 'notFound';
        },
    },
    // render (h) {
    //     return h(this.ViewComponent);
    // },
});
export {
    vm,
};
Vue.config.devtools = true;
window.vm = vm;
